import { Record } from 'immutable';

const keys: Fields = {
  approved: 0,
};

interface Fields {
  approved: number;
}

export default class InviteRequestStatusCountRecord extends Record<Fields>(
  keys
) {}
